export default function getDistanceInMeters(
    lat1,
    lon1,
    lat2,
    lon2
) {

    const R = 6371000;

    const toRad = value =>
        (value * Math.PI) / 180;

    const dLat =
        toRad(Number(lat2) - Number(lat1));

    const dLon =
        toRad(Number(lon2) - Number(lon1));

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(Number(lat1))) *
        Math.cos(toRad(Number(lat2))) *
        Math.sin(dLon / 2) ** 2;

    const c =
        2 *
        Math.atan2(
            Math.sqrt(a),
            Math.sqrt(1 - a)
        );

    return R * c;
}